<div class="section d-flex flex-column" [formGroup]="sectionForm">
  <div class="d-flex flex-row justify-content-between align-items-center">
    <h4 class="title">Section</h4>
    <button class="btn btn-primary button btn-save" (click)="submit()">Save</button>
  </div>
  <div class="mt-3">
    <div class="col-12 text-normal p-0">Title
      <span style="color: red;">*</span>
    </div>
    <span></span>
    <mat-form-field appearance="outline" class=" w-100">
      <input matInput required [(ngModel)]="title" formControlName="title" maxlength="50">
      <mat-hint align="end">{{sectionForm.controls.title.value.length || 0}} / 50</mat-hint>
      <mat-error>{{sectionForm.controls.title.errors?.message}}</mat-error>
    </mat-form-field>
  </div>
  <div class="mt-3">
    <h5>Select Layout</h5>
    <mat-radio-group aria-label="Select an option" class="d-flex flex-row justify-content-between mt-3" formControlName="layout">
      <mat-radio-button [value]="1" class="w-100">
        <img src="../../../../../../assets/images/layout_1.png" alt="" class="w-100 h-100">
      </mat-radio-button>
      <mat-radio-button [value]="2" class="w-100" >
        <img src="../../../../../../assets/images/layout_2.png" alt="" class="w-100 h-100">
      </mat-radio-button>
      <mat-radio-button [value]="3" class="w-100" >
        <img src="../../../../../../assets/images/layout_3.png" alt="" class="w-100 h-100">
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>